/*
 * File: user.js
 * Project: <<marketing-system>>
 * File Created: 2018-8-21 11:51:4 AM
 * Author: xiongyang (yang.xiong@meicloud.com)
 * -----
 * Last Modified: 2018-05-14 8:02:02 pm
 * Modified By: xiongyang (yang.xiong@meicloud.com>) (<<git>>)
 * -----
 * Copyright © 2018 - MeiCloud, MeiCloud
 */
// import { getSession, setSession } from '@/utils';
import {
  CLEAR_PAGE_STORE,
  SET_POST_DATA,
  SET_POST_DATA_ID,
  SET_POST_DATA_NAME,
  SET_AD_INFO,
  SET_POST_DATA_POS,
  SET_POST_DATA_CHANNEL,
  SET_POST_DATA_PRODUCT_ARR,
  SET_POST_DATA_ASSOCIATE,
  SET_POST_DATA_CATEGORY,
  SET_ASSEMBLYLIST,
  SET_SELECTEDINDEX,
  SET_SELECTELEMENTINDEX,
  SET_SELECTED_TAB,
  SET_HOT_SPACE_INDEX,
  SET_ISVALIDCOMS,
  SET_ELEMENT,
  SET_ELEMENT_CONTENT,
  SET_TAB_COMPONENT_CONTENT,
  SET_HOT_SPACE,
  SET_PAGE_STATUS,
  SET_IS_TAB_PAGE,
  SET_SUB_COMPONENT,
  SET_PUB_STATUS,
  SET_PAGE_TYPE,
  SET_ISNEEDPRODUCTMODEL,
  SET_ISNEEDPRODUCTCATEGORY
} from '../mutation-types';
// const SESSIONNAME = 'pageManament';
// 状态
const state = {
  // 页面管理公用数据
  assemblyList: [],
  tabComponent: [],
  postData: {
    id: null,
    pageName: null, // 页面名称
    pagePosition: null, // 页面位置
    sourceSystem: null, // 展示渠道
    productArr: null, // 关联产品
    associationType: 0, // 关联类型
    productCategory: null, // 关联品类
    productCategoryName: null, // 关联品类
    dialogAds: [{adPosCode: null, adId: null}],
    floatAds: [{adPosCode: null, adId: null}]
  },
  pageStatus: null, // 页面状态 -1取消发布，-2退回编辑，-3已作废，0草稿，1已发布 ，2审核中，3待发布，4定时发布
  // 变更后新的页面状态(-1已作废 0草稿 1审核中 2审核通过)
  isPublished: false, // 0未发布(默认) 1发布中
  isScheduledPublish: false, // 0非定时发布(默认) 1定时发布
  isNeedProductModel: false, // 是否需要开启关联产品缺省校验
  isNeedProductCategory: false, // 是否需要开启关联品类缺省校验
  isValidComs: false, // 是否发起全局校验组件
  pageType: null, // 0 推荐模板  1 自定义模板 2 COLMO品牌模板
  selectedIndex: null, // 当前选中的组件
  selectedElementIndex: 0, // 当前选中的元素
  selectedTab: 0, // 当前选中的tab
  selectedHotSpaceIndex: null, // 当前选中的热区
  isTabPage: false // 是否是tab页
};

// 操作
const mutations = {
  [SET_PAGE_STATUS](state, data) {
    state.pageStatus = data;
  },
  [SET_IS_TAB_PAGE](state, data) {
    state.isTabPage = data;
  },
  [SET_SUB_COMPONENT](state, params) {
    var tabComponent = state.tabComponent;
    if (params instanceof Array) {
      // add
      tabComponent.splice(tabComponent.length, 0, ...params);
    } else if (params.newIndex === undefined) {
      // delete
      tabComponent.splice(params.index, params.delLen || 1);
      state.assemblyList = [];
    } else {
      // update
      var obj = tabComponent.splice(params.index, 1); // 获取目标组件
      obj[0].sequence = params.newIndex;
      tabComponent.splice(params.newIndex, 0, obj[0]);
      tabComponent[params.index].sequence = params.index;
      state.assemblyList = tabComponent[state.selectedTab].subComponent;
    }
    console.log('更新后的SET_SUB_COMPONENT');
  },
  [SET_PUB_STATUS](state, data) {
    state.isPublished = data[0];
    state.isScheduledPublish = data[1];
  },
  [CLEAR_PAGE_STORE](state, data) {
    // state.isValidComs = data;
    state.assemblyList.splice(0, state.assemblyList.length);
    state.tabComponent.splice(0, state.tabComponent.length);
    state.isValidComs = false; // 是否发起全局校验组件
    state.selectedIndex = null; // 当前选中的组件
    state.selectedElementIndex = 0; // 当前选中的元素
    state.selectedTab = 0; // 当前选中的元素
    state.selectedHotSpaceIndex = null; // 当前选中的热区
    state.isTabPage = false; 
    state.postData.associationType = 0;
  },
  [SET_ISNEEDPRODUCTMODEL](state, data) {
    state.isNeedProductModel = data;
  },
  [SET_ISNEEDPRODUCTCATEGORY](state, data) {
    state.isNeedProductCategory = data;
  },
  [SET_ISVALIDCOMS](state, data) {
    state.isValidComs = data;
  },
  [SET_SELECTEDINDEX](state, data) {
    state.selectedIndex = data;
    console.log('更新后的selectedIndex' + state.selectedIndex);
    // _setSession('selectedIndex', data);
  },
  [SET_SELECTELEMENTINDEX](state, data) {
    state.selectedElementIndex = data;
    console.log('更新后的selectedElementIndex' + state.selectedElementIndex);
    // _setSession('selectedElementIndex', data);
  },
  [SET_SELECTED_TAB](state, data) {
    let oldIndex = state.selectedTab;
    console.log('更新后的oldIndex' + oldIndex);
    // state.tabComponent[oldIndex].subComponent = JSON.parse(JSON.stringify(state.assemblyList));
    state.selectedTab = data;
    state.assemblyList = state.tabComponent[state.selectedTab].subComponent;
    console.log(JSON.parse(JSON.stringify(state.tabComponent)));
    console.log('更新后的selectedTab' + state.selectedTab);
  },
  [SET_HOT_SPACE_INDEX](state, data) {
    state.selectedHotSpaceIndex = data;
    console.log('更新后的selectedHotSpaceIndex' + state.selectedHotSpaceIndex);
    // _setSession('selectedHotSpaceIndex', data);
  },
  [SET_POST_DATA](state, data) {
    state.postData = data;
    // _setSession('postData', data);
  },
  [SET_POST_DATA_ID](state, data) {
    state.postData.id = data;
    // _setSession('postData', state.postData);
  },
  [SET_POST_DATA_NAME](state, data) {
    state.postData.pageName = data;
    // _setSession('postData', state.postData);
  },
  [SET_AD_INFO](state, data) {
    state.postData[data.parentKey][0][data.childKey] = data.value;
    // _setSession('postData', state.postData);
  },
  [SET_POST_DATA_POS](state, data) {
    state.postData.pagePosition = data;
    // _setSession('postData', state.postData);
  },
  [SET_POST_DATA_CHANNEL](state, data) {
    state.postData.sourceSystem = data;
    // _setSession('postData', state.postData);
  },
  [SET_POST_DATA_PRODUCT_ARR](state, data) {
    state.postData.productArr = data;
    console.log('productArr', data, state.postData);
  },
  [SET_POST_DATA_ASSOCIATE](state, data) {
    state.postData.associationType = data;
    console.log('associationType', data, state.postData);
  },
  [SET_POST_DATA_CATEGORY](state, data) {
    if (data) {
      state.postData.productCategory = data.category;
      state.postData.productCategoryName = data.initCategoryName;
      state.assemblyList.forEach(item => {
        if (item.assemblyId === 14) {
          item.content[0].categoryCode = data.category;
        }
      });
    } else {
      state.postData.productCategory = null;
      state.postData.productCategoryName = null;
    }
    console.log('productCategory', data, state.postData);
  },
  [SET_ASSEMBLYLIST](state, params) {
    console.log(params);
    var assemblyList = state.assemblyList;
    console.log(assemblyList);
    var content = params.content;
    if (content !== undefined) {
      if (params.key !== undefined) {
        // 单独更新
        assemblyList[state.selectedIndex][params.key] = content;
      } else if (params.newIndex !== undefined && Object.prototype.toString.call(content) === '[object Object]') {
        // 新增单个
        assemblyList.splice(params.newIndex, 0, content);
      } else {
        // 新增数组
        while (content.length) {
          assemblyList.push(content.shift());
        }
      }
    } else if (params.newIndex !== undefined) {
      // 替换顺序 sequence
      var obj = assemblyList.splice(params.index, 1); // 获取目标组件
      obj[0].sequence = params.newIndex;
      assemblyList.splice(params.newIndex, 0, obj[0]);
      assemblyList[params.index].sequence = params.index;
    } else {
      // 删除
      assemblyList.splice(params.index, params.delLen || 1);
    }
    console.log('更新后的队列：');
    console.log(state.assemblyList);
    // _setSession('assemblyList', assemblyList);
  },
  [SET_PAGE_TYPE](state, data) {
    state.pageType = data;
    // _setSession('pageType', data);
  },
  [SET_ELEMENT](state, params) {
    var assemblyList = state.assemblyList[state.selectedIndex];
    if (params.newIndex === undefined) {
      // delete
      assemblyList.content.splice(params.index, 1);
    } else {
      // update
      var content = assemblyList.content;
      var obj = content.splice(params.index, 1); // 获取目标组件
      obj[0].sequence = params.newIndex;
      content.splice(params.newIndex, 0, obj[0]);
      content[params.index].sequence = params.index;
    }
    // state.assemblyList = assemblyList;
    // _setSession('assemblyList', assemblyList);
  },
  [SET_HOT_SPACE](state, params) {
    var assemblyList = state.assemblyList[state.selectedIndex];
    assemblyList.hotSpaceList = assemblyList.hotSpaceList || [];
    if (params.command === '-') {
      // delete
      assemblyList.hotSpaceList.splice(params.index, 1, ...params.item);
    } else {
      // add
      assemblyList.hotSpaceList.push({
        sourceType: 0,
        link: null,
        title: null,
        articleId: null,
        featuredId: null,
        featuredType: null,
        width: 30,
        height: 30,
        left: 0,
        top: 0,
      });
    }
  },
  [SET_ELEMENT_CONTENT](state, params) {
    var assemblyList = state.assemblyList[state.selectedIndex];
    if (params.index === undefined) {
      // params.content typeof Array
      // 全量更新
      assemblyList.content.splice(0, assemblyList.content.length);
      // 清空
      var content = params.content;
      while (content.length) {
        assemblyList.content.push(content.shift());
      }
      // 拼接数组
    } else {
      // params.content typeof Object
      // update
      assemblyList.content.splice(params.index, 1, params.content);
    }
    // _setSession('assemblyList', assemblyList);
  },
  [SET_TAB_COMPONENT_CONTENT](state, params) {
    console.log('SET_TAB_COMPONENT_CONTENT', 'state.selectedTab');
    var tabComponent = state.tabComponent[state.selectedTab];
    tabComponent.componentTitle = params.componentTitle;
  }
};

// 方法
const actions = {
  setPageStatus({ commit }, data) {
    commit('SET_PAGE_STATUS', data);
  },
  setIsTabPage({ commit }, data) {
    commit('SET_IS_TAB_PAGE', data);
  },
  setTabComponent({ commit }, data) {
    commit('SET_SUB_COMPONENT', data);
  },
  setPubStatus({ commit }, data) {
    commit('SET_PUB_STATUS', data);
  },
  clearPageStore({ commit }, data) {
    commit('CLEAR_PAGE_STORE', data);
  },
  setElementContent({ commit }, data) {
    commit('SET_ELEMENT_CONTENT', data);
  },
  setTabComponentContent({ commit }, data) {
    commit('SET_TAB_COMPONENT_CONTENT', data);
  },
  setElement({ commit }, data) {
    commit('SET_ELEMENT', data);
  },
  setHotSpace({ commit }, data) {
    commit('SET_HOT_SPACE', data);
  },
  setIsNeedProductModel({ commit }, data) {
    commit('SET_ISNEEDPRODUCTMODEL', data);
  },
  setIsNeedProductCategory({ commit }, data) {
    commit('SET_ISNEEDPRODUCTCATEGORY', data);
  },
  setIsValidComs({ commit }, data) {
    commit('SET_ISVALIDCOMS', data);
  },
  setSelectedIndex({ commit }, data) {
    commit('SET_SELECTEDINDEX', data);
  },
  // 设置用户菜单
  setPostData({ commit }, data) {
    commit('SET_POST_DATA', data);
  },
  setId({ commit }, data) {
    commit('SET_POST_DATA_ID', data);
  },
  setPageName({ commit }, data) {
    commit('SET_POST_DATA_NAME', data);
  },
  setAdInfo({ commit }, data) {
    commit('SET_AD_INFO', data);
  },
  setPagePosition({ commit }, data) {
    commit('SET_POST_DATA_POS', data);
  },
  setSourceSystem({ commit }, data) {
    commit('SET_POST_DATA_CHANNEL', data);
  },
  setProductArr({ commit }, data) {
    commit('SET_POST_DATA_PRODUCT_ARR', data);
  },
  setAssociationType({ commit }, data) {
    commit('SET_POST_DATA_ASSOCIATE', data);
  },
  setProductCategory({ commit }, data) {
    commit('SET_POST_DATA_CATEGORY', data);
  },
  setAssemblyList({ commit }, data) {
    commit('SET_ASSEMBLYLIST', data);
  },
  setSelectedElementIndex({ commit }, data) {
    commit('SET_SELECTELEMENTINDEX', data);
  },
  setSelectedTab({ commit }, data) {
    commit('SET_SELECTED_TAB', data);
  },
  setHotSpaceIndex({ commit }, data) {
    commit('SET_HOT_SPACE_INDEX', data);
  },
  setPageType({ commit }, data) {
    commit('SET_PAGE_TYPE', data);
  }
};

const getters = {
  // 用户菜单
  pageStatus: state => state.pageStatus,
  isTabPage: state => state.isTabPage,
  isPublished: state => state.isPublished,
  isScheduledPublish: state => state.isScheduledPublish,
  isNeedProductModel: state => state.isNeedProductModel,
  isNeedProductCategory: state => state.isNeedProductCategory,
  isValidComs: state => state.isValidComs,
  pageType: state => state.pageType,
  selectedIndex: state => state.selectedIndex,
  selectedElementIndex: state => state.selectedElementIndex,
  selectedTab: state => state.selectedTab,
  selectedHotSpaceIndex: state => state.selectedHotSpaceIndex,
  postData: state => state.postData,
  id: state => state.postData.id,
  pageName: state => state.postData.pageName,
  pagePosition: state => state.postData.pagePosition,
  sourceSystem: state => state.postData.sourceSystem,
  productArr: state => state.postData.productArr,
  associationType: state => state.postData.associationType,
  productCategory: state => state.postData.productCategory,
  productCategoryName: state => state.postData.productCategoryName,
  dialogAds: state => state.postData.dialogAds,
  floatAds: state => state.postData.floatAds,
  assemblyList: state => state.assemblyList,
  tabComponent: state => state.tabComponent,
};

// function _getSession(name) {
//   return getSession(SESSIONNAME + '_' + name) || {};
// }

// function _setSession(name, data) {
//   setSession(SESSIONNAME + '_' + name, data);
// }

export default {
  // 开启命名空间
  namespaced: true,
  getters,
  state,
  mutations,
  actions
};
